import React from 'react';
import moment from 'moment';
import { Chip } from '@material-ui/core';

import Estatus from '../../componentes/Estatus';
import Listados from '../../contenedores/Listados';
import { PLANTILLAS_CONTRATO } from '../../configuraciones/endpoints';

const cabeceros = [
  { label: '#', key: 'id', width: 60 },
  { label: 'Nombre del Machote', key: 'nombre' },
  {
    label: 'Tipo',
    transform: ({ tipo }) => (
      <Chip
        size="small"
        label={tipo === 'CREDITO' ? 'Crédito' : 'Contado'}
        style={{
          backgroundColor: tipo === 'CREDITO' ? '#e3f2fd' : '#e8f5e9',
          color: tipo === 'CREDITO' ? '#1565c0' : '#2e7d32',
          fontWeight: 600,
        }}
      />
    ),
  },
  {
    label: 'Fecha de Creación',
    transform: ({ fechaCreacion }) => (fechaCreacion ? moment(fechaCreacion).format('DD/MM/YYYY') : '---'),
  },
  {
    label: 'Estatus',
    transform: ({ activo }) => <Estatus habilitado={activo} activo={activo} />,
  },
];

const PlantillasContrato = ({ history, location }) => (
  <Listados
    titulo="Plantillas de Contratos"
    subtitulo="Catálogo de machotes y formatos editables"
    placeHolder="Buscar por nombre..."
    history={history}
    location={location}
    showActions
    cabeceros={cabeceros}
    apiKey={PLANTILLAS_CONTRATO}
  />
);

export default PlantillasContrato;
